import React from 'react';
import { enableWhyDidYouRender } from './project-config.json';

const whyDidYouRender = {
  init: async () => {
    if (process.env.NODE_ENV === 'development' && enableWhyDidYouRender) {

      const render = await import('@welldone-software/why-did-you-render');
      render.default(React, {
        logOnDifferentValues: false,
        include: [
          /^HomePage/,
          /^StoreDetails/,
        ]
      });
    }
  }
};
export { whyDidYouRender };